module.exports = __webpack_public_path__ + "img/poster5.ebd9cb4c.jpg";